export default __webpack_public_path__ + "static/media/facbookSvg.80663f54.svg";